<template>
  <NuxtImg
    :src="imageUrl"
    :alt="alt"
    :style="{ 'min-height': minHeight }"
    :loading="loading"
  />
</template>

<script setup lang="ts">
import { useMediaLocalization } from '../composables/mediaLocalization';

const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    required: true,
  },
  minHeight: {
    type: String,
    required: true,
  },
  localize: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: String as () => 'lazy' | 'eager',
    default: 'lazy',
  },
});

const { getMediaLocaleUrl } = useMediaLocalization();

const imageUrl = computed(() => {
  if (!props.localize) {
    return props.src;
  }

  return getMediaLocaleUrl(props.src, 'images');
});
</script>
